import React from 'react';
import ProductHeaderDesktop from './product-header-desktop';
import ProductHeaderMobile from './product-header-mobile';
import Viewport, { ViewportContext } from '../../../../components/viewport';

const ProductHeader = React.memo(props => (
  <>
    <Viewport desktop tablet>
      <ProductHeaderDesktop {...props} />
    </Viewport>
    <Viewport mobile>
      <ProductHeaderMobile {...props} />
    </Viewport>
  </>
));

export default React.forwardRef((props, ref) => (
  <ViewportContext.Consumer>
    {({ isDesktop }) => (
      <ProductHeader
        {...props}
        showPriceHistory={isDesktop}
        showProductSummary={isDesktop}
        innerRef={ref}
      />
    )}
  </ViewportContext.Consumer>
));
